export const QueryParamConstant = {
	FEATURE_ENV: 'featureEnv',
	SHORT_LIVED_TOKEN: 'sltTkn',
	TOKEN: 'token',
	ROUTING_KEY: 'routingKey',
};

export const REQUEST_HEADERS = {
	AUTHORIZATION: 'Authorization',
	TOKEN: 'x-auth-token',
	ACCEPT: 'accept',
	CONTENT_TYPE: 'Content-Type',
	DEVICE_INFO: 'x-device-info',
	DEVICE_TYPE: 'x-device-type',
	CHECKOUT_TYPE: 'checkoutType',
	FINGERPRINT: 'x-browser-fingerprint',
	DEVICE_FINGERPRINT: 'x-device-fingerprint',
	FEATURE_ENV: 'x-request-env',
	CREDENTIAL: 'credential',
	ROUTING_KEY: 'x-routing-key',
};

/**
 * Represents standard HTTP request headers.
 * It can be a Headers object, a record of string key-value pairs, or an array of string pairs.
 */
export type HeadersInit = Headers | Record<string, string> | [string, string][];

/**
 * Enumeration for HTTP request methods.
 */
export enum RequestMethod {
	GET = 'GET',
	POST = 'POST',
	PUT = 'PUT',
	DELETE = 'DELETE',
	PATCH = 'PATCH',
	HEAD = 'HEAD',
	OPTIONS = 'OPTIONS',
}

/**
 * Custom error class for failed API requests.
 */
export class ApiClientError extends Error {
	public status: number;
	public url: string;
	public method: RequestMethod;
	public details?: unknown;

	constructor(
		message: string,
		status: number,
		url: string,
		method: RequestMethod,
		details?: unknown,
	) {
		super(message);
		this.name = 'ApiClientError';
		this.status = status;
		this.url = url;
		this.method = method;
		this.details = details;
	}
}

/**
 * Configuration options for the ApiClient constructor.
 */
export interface IApiClientConfig {
	baseURL: string;
	defaultHeaders?: HeadersInit;
	allowCredentials?: boolean;
}

/**
 * Parameters for individual GET/POST/etc. requests.
 */
export interface IRequestParam<T = unknown> {
	headers?: HeadersInit;
	body?: T;
}

export interface IApiRequestEventsPayload {
	apiUrl: string;
	methodType: RequestMethod;
	timeStamp: number;
}

export interface APIEventsPayload {
	apiUrl: string;
	methodType: RequestMethod;
	timeStamp: number;
	statusCode: number;
	responseTime: number;
}

export interface IApiResponseEventsPayload extends APIEventsPayload {
	statusCode: number;
	responseTime: number;
}

export interface IApiEventHandlers {
	onApiCallInit?: (config: IApiRequestEventsPayload) => void;
	onApiCallSuccess?: (config: IApiResponseEventsPayload) => void;
	onApiCallFailed?: (config: IApiResponseEventsPayload) => void;
}

/**
 * Full configuration for a request, including retry and timeout settings.
 */
export interface IRequestOptions extends IRequestParam, IApiEventHandlers {
	method: RequestMethod;
	timeout?: number;
	maxRetryLimit?: number;
	retryDelay?: number;
}

export const DEFAULT_TIMEOUT = 30000;
export const DEFAULT_RETRY_DELAY = 200;
export const DEFAULT_GET_RETRIES = 2;
export const DEFAULT_POST_RETRIES = 0;
